import { Href, RecentChats } from "../../../../../../constants";
import { Link } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../../../reduxToolkit/hooks";
import { changeChat, createNewChatAsync } from "../../../../../../reduxToolkit/reducers/chatSlice";
import { Badge } from "reactstrap";
import { MemberItems } from "../../../../../../types/Applications";
import { dynamicImage } from "../../../../../../utils";
import { Image } from "../../../../../../coreComponents/Image";
import SearchNotFoundClass from "../../../../../../coreComponents/SearchNotFoundClass";

// This component displays a list of recent chats and allows users to switch between conversations.
export const ChatTabs = () => {
  const { members, selectedUser, currentUser, chats } = useAppSelector((state) => state.chat);
  var activeChat = 0;
  if (selectedUser != null) activeChat = selectedUser.id;
  const dispatch = useAppDispatch();
  const changeChatClick = (selectUser: number) => {
    const currentUserId = currentUser?.id;
    const currentChat = chats.find((x: { users: number[] }) => currentUser?.id !== undefined && x.users.includes(currentUser?.id) && x.users.includes(selectUser));
    if (currentChat) dispatch(changeChat(selectUser));
    else dispatch(createNewChatAsync({ currentUserId, selectUser, chats }));
  };

  return (
    <>
      <div className="common-space">
        <p>{RecentChats}</p>
        <div className="header-top">
          <Link className="badge-light-primary f-w-500 btn" to={Href}>
            <i className="fa fa-plus" />
          </Link>
        </div>
      </div>
      {members && members.length > 0 ? (
        <ul className="chats-user custom-scrollbar">
          {/* Mapping through members to display chat list of members excluding the current user from the list*/}
          {members
            .filter((x: MemberItems) => x.id !== currentUser?.id)
            .map((item: MemberItems, id: number) => (
              <li className={`common-space ${activeChat === item.id ? "active" : ""}`} key={id} onClick={() => changeChatClick(item.id)}>
                <div className="chat-time">
                  <div className="active-profile">
                    <Image className="img-fluid rounded-circle" src={dynamicImage(`${item.image}`)} alt="user" />
                    <div className={`status bg-${item.online}`} />
                  </div>
                  <div>
                    <span>{item.name}</span>
                    <p>{item.status}</p>
                  </div>
                </div>
                <div>
                  <p>{item.time} </p>
                  {item.badge && <Badge color="success">{item.badge}</Badge>}
                </div>
              </li>
            ))}
        </ul>
      ) : (
        <SearchNotFoundClass word="Contact" />
      )}
    </>
  );
};
